export default {"src":"/_next/static/image/public/images/report_revamp_card.0db91d3d1878331910579f12eda04fde.svg","height":36,"width":36};